module.exports = __webpack_public_path__ + "media/images/emblems/Huettlingen-Turgovio-Blazono-3557fde86ce896ab8e167fdb6ddd69be.png";